import React from 'react';
import { CornerDialog, Text, Pane, SmallCrossIcon } from 'evergreen-ui';
import { useDispatch, useSelector } from 'react-redux';
import { clearSearch } from '../../actions/search';
import { IconButton } from '../../components/index';
import { history, ls } from 'cademy-shared-web';
import './Footer.css';
import { AnchorComponent, LinkComponent } from '../_ui/A';
import { Environment } from 'services/Environment';

export const Footer = (props) => {
    const dispatch = useDispatch();
    const { utm_details } = useSelector((store) => store.profile);
    if (
        history.location.pathname.split('/')[1] === 'embed' ||
        history.location.pathname.split('/')[1] === 'checkout'
    ) {
        return null;
    }

    return (
        <div style={{ backgroundColor: 'var(--bg-1)', width: '100%', marginTop: '50px' }}>
            <footer
                style={props.style}
                className={history.location.pathname === '/' ? 'container-wide' : 'container'}
            >
                <div>
                    <span style={{ textAlign: 'center', display: 'block', paddingTop: '50px' }}>
                        Made with{' '}
                        <span role="img" aria-label="Heart emoji">
                            ❤️
                        </span>{' '}
                        in Edinburgh{' '}
                        <span role="img" aria-label="Scotland flag">
                            🏴󠁧󠁢󠁳󠁣󠁴󠁿
                        </span>
                    </span>
                </div>
                <div className="footer">
                    <div>
                        <span className="footer-headings">Educators</span>
                        <ul style={{ paddingInlineStart: 0 }}>
                            <li>
                                <AnchorComponent
                                    href={`${Environment.MARKETPLACE_URL}/for-educators`}
                                    onClick={() => window.scroll({ top: 0, behavior: 'smooth' })}
                                >
                                    Tools for Educators
                                </AnchorComponent>
                            </li>

                            <li>
                                <AnchorComponent
                                    href={`${Environment.MARKETPLACE_URL}/create-educator?${utm_details?.redirectRef}`}
                                >
                                    Create a Course
                                </AnchorComponent>
                            </li>

                            <li>
                                <AnchorComponent
                                    href={`${Environment.MARKETPLACE_URL}/login`}
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    Educator log in
                                </AnchorComponent>
                            </li>

                            <li>
                                <AnchorComponent
                                    href={`${Environment.MARKETPLACE_URL}/login?${utm_details?.redirectRef}`}
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    Educator sign up
                                </AnchorComponent>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <span className="footer-headings">Browse</span>
                        <ul style={{ paddingInlineStart: 0 }}>
                            <li>
                                <LinkComponent
                                    to="/"
                                    onClick={() => {
                                        dispatch(clearSearch());
                                        window.scrollTo(0, 0);
                                    }}
                                >
                                    Home
                                </LinkComponent>
                            </li>
                            <li>
                                <LinkComponent
                                    to="/gift-checkout"
                                    onClick={() => {
                                        dispatch(clearSearch());
                                        window.scrollTo(0, 0);
                                    }}
                                >
                                    Vouchers
                                </LinkComponent>
                            </li>
                            <li>
                                <LinkComponent
                                    to="/categories"
                                    onClick={() => {
                                        dispatch(clearSearch());
                                        window.scrollTo(0, 0);
                                    }}
                                >
                                    Categories
                                </LinkComponent>
                            </li>
                            <li>
                                <AnchorComponent href={`${Environment.MARKETPLACE_URL}/login`}>
                                    Student Log in
                                </AnchorComponent>
                            </li>
                            <li>
                                <AnchorComponent href={`${Environment.MARKETPLACE_URL}/login`}>
                                    Student Sign up
                                </AnchorComponent>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <span className="footer-headings">Company</span>
                        <ul style={{ paddingInlineStart: 0 }}>
                            <li>
                                <LinkComponent to="/about" onClick={() => window.scrollTo(0, 0)}>
                                    About us
                                </LinkComponent>
                            </li>
                            <li>
                                <AnchorComponent
                                    href="https://cademy.notion.site/Careers-at-Cademy-49b1d4dbefe14b2c971725b5e518166b"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    Careers
                                </AnchorComponent>
                            </li>
                            <li>
                                <AnchorComponent
                                    href={`${Environment.CADEMY_ROADMAP_URL}/changelog`}
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    Company & Product Updates
                                </AnchorComponent>
                            </li>
                            <li>
                                <LinkComponent to="/privacy" onClick={() => window.scrollTo(0, 0)}>
                                    Privacy Policy
                                </LinkComponent>
                            </li>
                            <li>
                                <LinkComponent to="/terms" onClick={() => window.scrollTo(0, 0)}>
                                    Terms of Service
                                </LinkComponent>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <span className="footer-headings">Contact</span>

                        <div>
                            <ul style={{ paddingInlineStart: 0 }}>
                                <li>
                                    <LinkComponent
                                        to="/contact"
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Contact us
                                    </LinkComponent>
                                </li>
                                <li>
                                    <AnchorComponent
                                        href={`mailto:${Environment.CADEMY_SUPPORT_EMAIL_ADDRESS}`}
                                        target="_blank"
                                        rel="noopener noreferrer nofollow"
                                    >
                                        Email
                                    </AnchorComponent>
                                </li>
                                <li>
                                    <AnchorComponent
                                        href="https://twitter.com/cademy__"
                                        target="_blank"
                                        rel="noopener noreferrer nofollow"
                                    >
                                        Twitter
                                    </AnchorComponent>
                                </li>
                                <li>
                                    <AnchorComponent
                                        href="https://www.facebook.com/cademy.co.uk"
                                        target="_blank"
                                        rel="noopener noreferrer nofollow"
                                    >
                                        Facebook
                                    </AnchorComponent>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <CornerDialog
                    hasClose={false}
                    hasFooter={false}
                    isShown={!ls.getItem('cademyCookies')}
                    onCloseComplete={() => ls.setItem('cademyCookies', 'allowed')}
                    containerProps={{ className: 'cookies-banner' }}
                    children={({ close }) => {
                        return (
                            <Pane display="flex" alignItems="center">
                                <Text size={300} color="muted">
                                    By using this website, you agree to our{' '}
                                    <span role="img" aria-label="Cookie emoji">
                                        🍪
                                    </span>{' '}
                                    <LinkComponent to="/privacy">
                                        cookies & privacy policy.
                                    </LinkComponent>
                                </Text>
                                <IconButton
                                    small
                                    margin="0 0 0 10px"
                                    onClick={close}
                                    desc="Dismiss cookies banner"
                                >
                                    <SmallCrossIcon />
                                </IconButton>
                            </Pane>
                        );
                    }}
                />
            </footer>
        </div>
    );
};
